import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';
import { DataService } from '../../data.service';

// NAPLO – NAV Online Számlázó: a tárhely-fiók(ok)on keresztül letöltött OSA számlák
// listája, PDF-megnyitás, partner-kinyerés és könyvelés. Korábban a Tárhely fülön volt,
// önálló menübe kiemelve.
@Component({
  selector: 'app-naplo-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['../naplo-shared.scss'],
})
export class NavComponent implements OnInit {
  navSzamlak: any[] = [];         // NAV Online Számlázó számlái
  hozzarendelesek: any[] = [];    // az aktív ügyfélhez rendelt fiók+postafiók (a szinkronhoz kell)
  szuro = '';

  constructor(private naplo: NaploService, private toast: ToastController, private alert: AlertController, private loadingCtrl: LoadingController,
              private data: DataService) {}

  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    if (!this.aktiv.ugyfelId) return;
    await Promise.all([this.betoltNav(), this.betoltHozzar()]);
  }

  async betoltNav() {
    try { this.navSzamlak = await this.naplo.get('/nav/szamlazo/' + this.aktiv.ugyfelId).then((r: any) => r.szamlak || []); }
    catch { /* csendes */ }
  }
  async betoltHozzar() {
    try { this.hozzarendelesek = await this.naplo.get('/ugyfelkapu/hozzarendelesek/' + this.aktiv.ugyfelId); }
    catch { /* csendes */ }
  }

  // Cím összefűzése (irsz település, cím) – üres tagokat kihagyva.
  cim(s: any) { return [s.partner_irsz, s.partner_telepules, s.partner_cim].filter((x) => x).join(' '); }

  get szurtSzamlak() {
    const s = this.szuro.trim().toLowerCase();
    if (!s) return this.navSzamlak;
    return this.navSzamlak.filter(x => (x.szamlaszam || '').toLowerCase().includes(s) || (x.partner || '').toLowerCase().includes(s) || (x.partner_adoszam || '').toLowerCase().includes(s));
  }

  // A szinkron (belépés + adózó-váltás + lista + MINDEN PDF letöltése) percekig tart. Korábban egy
  // blokkoló "loading" overlay alatt, egyetlen HTTP-kérésben futott: a böngésző bontotta a
  // kapcsolatot, a felület "sikertelen"-t írt, a szerver meg közben végig dolgozott. Most a
  // szerveren fut háttérfeladatként – a gomb azonnal elenged, a haladás a fejléc alatti sávban van.
  szinkronFeladatId: string | null = null;
  szinkronHalad: any = null;

  private async figyelmeztet(m: string) { (await this.toast.create({ message: m, duration: 6000, color: "warning", position: "top" })).present(); }

  async navSzinkron() {
    if (!this.hozzarendelesek.length) { this.hiba('Előbb rendelj hozzá egy tárhely-fiókot ehhez az ügyfélhez (Tárhely fül).'); return; }
    try {
      const id = await this.naplo.feladatIndit('/nav/szamlazo/szinkron-inditas/' + this.aktiv.ugyfelId, {});
      if (!id) { this.hiba('Nem sikerült elindítani a szinkront.'); return; }
      this.szinkronFeladatId = id;
      this.ok('A NAV Számlázó szinkron elindult a háttérben – elnavigálhatsz, a fejlécben követheted.');
      const f = await this.naplo.feladatVar(id, (h) => { this.szinkronHalad = h; });
      this.szinkronFeladatId = null; this.szinkronHalad = null;
      await this.betoltNav();
      const e = f?.eredmeny || {};
      this.ok(`NAV Számlázó kész. Összes: ${e.osszes ?? 0}${e.lista_osszes ? ' / ' + e.lista_osszes + ' a NAV listáján' : ''}, új: ${e.uj ?? 0}, PDF: ${e.pdf ?? 0}.`);
      // Amit a NAV nem adott ki (hiányzó számlák, elmaradt PDF-ek), azt külön is kiírjuk.
      for (const u of (e.figyelmeztetes || [])) this.figyelmeztet(u);
    } catch (e: any) {
      this.szinkronFeladatId = null; this.szinkronHalad = null;
      this.hiba(e?.error?.error || e?.message || 'NAV Számlázó szinkron sikertelen.');
    }
  }
  // Tokennel töltjük le (a NAPLO kiszolgálója token nélkül nem ad ki fájlt) – DataService.megnyitFajl.
  navPdf(s: any) { this.data.megnyitFajl('/api/naplo/nav/szamlazo/pdf/' + s.id, 'NAV számla PDF'); }
  async navPartnerKinyer() {
    const l = await this.loadingCtrl.create({ message: 'Partnerek kinyerése a NAV PDF-ekből…' });
    l.present();
    try { const r: any = await this.naplo.post('/nav/szamlazo/partner-kinyer/' + this.aktiv.ugyfelId, {}); this.ok(`Partnerek kinyerve a PDF-ekből: ${r?.letrehozott ?? 0} új.`); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült kinyerni.'); }
    finally { l.dismiss(); }
  }
  async navKonyvel(s: any) {
    if (s.konyvelt) return this.hiba('Ez a számla már le van könyvelve.');
    const l = await this.loadingCtrl.create({ message: 'Könyvelés…' });
    l.present();
    try { await this.naplo.post('/nav/szamlazo/konyvel/' + s.id, {}); await this.betoltNav(); this.ok('Lekönyvelve – az OSA-ban is zöld lesz.'); }
    catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült könyvelni.'); }
    finally { l.dismiss(); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2000, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3500, color: 'danger' })).present(); }
}
